import { createStore } from "vuex";
import { Howl } from "howler";

// Page Transition Directions
const enter_up = "enterUp";
const enter_down = "enterDown";
const enter_right = "enterRight";
const enter_left = "enterLeft";
const enter_down_left = "enterDownLeft";
const enter_down_right = "enterDownRight";
const enter_up_left = "enterUpLeft";
const enter_up_right = "enterUpRight";
const enter_center = "enterCenter";

// Sound Paths
const nudge_path = "audio/2072-nudge-01.wav";
const bell_path = "audio/2072-bells-01.wav";
const soundscape_path = "audio/2072-Earthbound.m4a";
const fade_duration = 50;
const longer_fade_duration = 300;

// Create a new store instance.
const store = createStore({
  state() {
    return {
      pageTransition: "enterCenter",
      effectsMuted: false,
      soundscapeMuted: false,
      sound: {
        nudgeSound: null,
        nudgeInstances: [],
        bellSound: null,
        bellInstances: [],
        soundscapeSound: null,
        soundscapeInstance: null
      },
      savedPositions: {},
      previousPage: null
    };
  },
  getters: {
    isSoundscapePlaying(state) {
      return state.sound.soundscapeSound.playing(
        state.sound.soundscapeInstance
      );
    }
  },
  actions: {
    setupSounds({ state }) {
      state.sound.nudgeSound = new Howl({
        src: [nudge_path],
        loop: false,
        volume: 1,
        onplayerror: function (id, e) {
          console.log(id, e);
        },
        onplay: function (id) {
          // state.playing = true;
        },
        onend: function (id) {
          // state.playing = false;
        }
      });

      state.sound.bellSound = new Howl({
        src: [bell_path],
        loop: false,
        volume: 1,
        onplayerror: function (id, e) {
          console.log(id, e);
        },
        onplay: function (id) {
          // state.playing = true;
        },
        onend: function (id) {
          // state.playing = false;
        }
      });

      state.sound.soundscapeSound = new Howl({
        src: [soundscape_path],
        loop: true,
        volume: 1,
        onplayerror: function (id, e) {
          console.log(id, e);
        },
        onplay: function (id) {
          // state.playing = true;
        },
        onend: function (id) {
          // state.playing = false;
        }
      });
    },
    playNudge({ state }) {
      if (state.effectsMuted) {
        return;
      }
      let nudgeInstance = state.sound.nudgeSound.play();
      state.sound.nudgeSound.fade(0, 1, fade_duration, nudgeInstance);
      state.sound.nudgeInstances.push(nudgeInstance);
    },
    playBell({ state }) {
      if (state.effectsMuted) {
        return;
      }
      let bellInstance = state.sound.bellSound.play();
      state.sound.bellSound.fade(0, 1, fade_duration, bellInstance);
      state.sound.bellInstances.push(bellInstance);
    },
    playSoundscape({ state }) {
      if (state.soundscapeMuted) {
        return;
      }

      if (state.sound.soundscapeSound == null) {
        return;
      }
      let isPlaying = state.sound.soundscapeSound.playing(
        state.sound.soundscapeInstance
      );
      if (!isPlaying) {
        state.sound.soundscapeInstance = state.sound.soundscapeSound.play();
        state.sound.soundscapeSound.fade(
          0,
          1,
          longer_fade_duration,
          state.sound.soundscapeInstance
        );
      }
    },
    pauseSoundscape({ state }) {
      state.sound.soundscapeSound.fade(
        1,
        0,
        longer_fade_duration,
        state.sound.soundscapeInstance
      );
      setTimeout(() => {
        state.sound.soundscapeSound.pause(state.sound.soundscapeInstance);
      }, longer_fade_duration);
    },
    toggleSoundscape(context) {
      context.state.soundscapeMuted = !context.state.soundscapeMuted;

      if (context.state.soundscapeMuted) {
        context.dispatch("pauseSoundscape");
      } else {
        context.dispatch("playSoundscape");
      }
    },
    toggleEffects(context) {
      context.state.effectsMuted = !context.state.effectsMuted;

      if (context.state.effectsMuted) {
        context.dispatch("pauseEffects");
      }
    },
    pauseEffects(context) {
      // run thru and pause
    },
    prepareToNavigate(context, { from, to, position }) {
      // Save scroll position
      context.commit("setPageSavedPosition", { from, position });

      // Save position to go back from subscribe
      if (to === "/subscribe") {
        context.commit("setPreviousPage", from);
      } else if (from === "/subscribe") {
        context.commit("setPreviousPage", null);
      }

      // Set CSS Transition Name
      if (from === "/" && to === "/theory") {
        context.commit("setToEnterLeft");
      } else if (from === "/" && to === "/placemaking") {
        context.commit("setToEnterUp");
      } else if (from === "/placemaking" && to === "/traversing") {
        context.commit("setToEnterLeft");
      } else if (from === "/traversing" && to === "/theory") {
        context.commit("setToEnterDown");
      } else if (from === "/traversing" && to === "/placemaking") {
        context.commit("setToEnterRight");
      } else if (from === "/theory" && to === "/") {
        context.commit("setToEnterRight");
      } else if (from === "/placemaking" && to === "/theory") {
        context.commit("setToEnterDownLeft");
      } else if (from === "/placemaking" && to === "/") {
        context.commit("setToEnterDown");
      } else if (from === "/traversing" && to === "/theory") {
        context.commit("setToEnterDown");
      } else if (from === "/theory" && to === "/traversing") {
        context.commit("setToEnterUp");
      } else if (from === "/traversing" && to === "/") {
        context.commit("setToEnterDownRight");
      } else if (from === "/" && to === "/traversing") {
        context.commit("setToEnterUpLeft");
      } else if (from === "/placemaking" && to === "/theory") {
        context.commit("setToEnterDownLeft");
      } else if (from === "/theory" && to === "/placemaking") {
        context.commit("setToEnterUpRight");
      } else if (to === "/subscribe" || from === "/subscribe") {
        context.commit("setToEnterCenter");
      }

      // console.log(from, to);
    }
  },
  mutations: {
    setToEnterUp(state) {
      state.pageTransition = enter_up;
    },
    setToEnterDown(state) {
      state.pageTransition = enter_down;
    },
    setToEnterRight(state) {
      state.pageTransition = enter_right;
    },
    setToEnterLeft(state) {
      state.pageTransition = enter_left;
    },
    setToEnterDownLeft(state) {
      state.pageTransition = enter_down_left;
    },
    setToEnterDownRight(state) {
      state.pageTransition = enter_down_right;
    },
    setToEnterUpLeft(state) {
      state.pageTransition = enter_up_left;
    },
    setToEnterUpRight(state) {
      state.pageTransition = enter_up_right;
    },
    setToEnterCenter(state) {
      state.pageTransition = enter_center;
    },
    setPageSavedPosition(state, { from, position }) {
      state.savedPositions[from] = position;
    },
    setPreviousPage(state, page) {
      state.previousPage = page;
    }
  }
});

export default store;
